import './App.css';

import { Route, Routes } from 'react-router-dom';
import AuthDialogLogin from './dialog/LoginDialog';
import LandingPage from './pages/landingpage/LandingPage';

import AuthDialogSignUp from './dialog/AuthDialogSignUp';

import 'bootstrap/dist/css/bootstrap.css';
import { Provider } from 'react-redux';
import { store } from './Store';
import AuthDialogCreateNewPasswordConfirm from './dialog/AuthDialogCreateNewPasswordConfirm';
import AuthDialogMailRegistered from './dialog/AuthDialogMailRegistered';
import AuthDialogPasswordReset from './dialog/AuthDialogPasswordReset';
import AuthDialogPasswordResetMail from './dialog/AuthDialogPasswordResetMail';
import AuthDialogSendRegistrationMail from './dialog/AuthDialogSendRegistrationMail';
import AuthDialogCreateNewPassword from './dialog/CreateNewPasswordFromResetLinkDialog';
import ModalMessageOkDialog from './dialog/ModalMessageOkDialog';
import Account from './pages/account/Account';
import AuftraggeberDetail from './pages/admin/auftraggeber/AuftraggeberDetail';
import AuftraggeberMain from './pages/admin/auftraggeber/AuftraggeberMain';
import DienstleistungDetail from './pages/admin/dienstleistung/DienstleistungDetail';
import DienstleistungMain from './pages/admin/dienstleistung/DienstleistungMain';
import MwstSatzMain from './pages/admin/mwstsatz/MwstSatzMain';
import PreiseDetail from './pages/admin/preise/PreiseDetail';
import PreiseMain from './pages/admin/preise/PreiseMain';
import ProfileDetail from './pages/admin/profiles/ProfileDetail';
import ProfileMain from './pages/admin/profiles/ProfileMain';
import RechnungsempfaengerDetail from './pages/admin/rechnungsempfaenger/RechnungsempfaengerDetail';
import RechnungsempfaengerMain from './pages/admin/rechnungsempfaenger/RechnungsempfaengerMain';
import AuftragDetails from './pages/auftrag/AuftragDetails';
import AuftragSearch from './pages/auftrag/AuftragSearch';
import EigeneAuftraegeDetail from './pages/eigeneauftraege/EigeneAuftraegeDetail';
import Ausgangsrechnungen from './pages/faktura/Ausgangsrechnungen';
import RechnungslaufDetail from './pages/faktura/RechnungslaufDetail';
import RechnungslaufListe from './pages/faktura/RechnungslaufListe';
import RechnungslaufVorschau from './pages/faktura/Rechnungslaufvorschau';
import FooterContact from './pages/footer/FooterContact';
import FooterDataprotection from './pages/footer/FooterDataprotection';
import FooterImprint from './pages/footer/FooterImprint';
import ManagerProfileAuftraege from './pages/manager/profiles/ManagerProfileAuftraege';
import ManagerProfileDetail from './pages/manager/profiles/ManagerProfileDetail';
import ManagerProfileMain from './pages/manager/profiles/ManagerProfileMain';
import PasswordResetLink from './pages/misc/PasswordReset';
import NeuerAuftrag from './pages/neuerAuftrag/NeuerAuftrag';
import TicketMain from './pages/tickets/TicketMain';
import { ProtectedRoute } from './util/ProtectedRoute';
import ChatListe from './pages/chat/ChatListe';
import ParameterMain from './pages/admin/parameter/ParameterMain';
import ParameterDetail from './pages/admin/parameter/ParameterDetail';
import PapierkorbMain from './pages/admin/papierkorb/PapierkorbMain';
import RechnungsnummerAnpassen from './pages/faktura/RechnungsnummerAnpassen';
import ListeAbrechenbareDienstleistungen from './pages/faktura/ListeAbrechenbareDienstleistungen';
import ToastComponent from './component/ToastComponent/ToastComponent';
import AuftragMain from './pages/auftrag/AuftragMain';
import ErrorMessages from './pages/admin/errormessages/ErrorMessages';
import AgSbAuftragsListe from './pages/ag_sachbearbeiter/AgSbAuftragsListe';

// declare global {
//   interface Window {
//     showLoginDialog: () => void;
//     closeLoginDialog: () => void;
//     showRegisterDialog: () => void;
//     closeRegisterDialog: () => void;
//     showVerifyEmailDialog: () => void;
//     closeVerifyEmailDialog: () => void;
//     showVerifyAccountDialog: () => void;
//     closeVerifyAccountDialog: () => void;
//     showChangePasswordDialog: () => void;
//     closeChangePasswordDialog: () => void;
//     tryRenderSubscriptionForm: (params: any) => void;
//   }
// }

export default function App() {

    return (
        <>
            <Provider store={store}>
                <AuthDialogLogin />
                <AuthDialogSignUp />
                <AuthDialogMailRegistered />
                <AuthDialogSendRegistrationMail />
                <AuthDialogPasswordReset />
                <AuthDialogPasswordResetMail />
                <AuthDialogCreateNewPassword />
                <AuthDialogCreateNewPasswordConfirm />
                <ModalMessageOkDialog />
                <ToastComponent />

                <Routes>
                    <Route path="/" element={<LandingPage />}></Route>

                    <Route path="/contact" element={<FooterContact />}></Route>
                    <Route path="/imprint" element={<FooterImprint />}></Route>
                    <Route path="/dataprotection" element={<FooterDataprotection />}></Route>

                    <Route path="/passwordreset/:uid" element={<PasswordResetLink />}></Route>
                    <Route path="/account" element={<Account />}></Route>

                    <Route path="/neuerauftrag" element={<NeuerAuftrag />}></Route>
                    <Route path="/eigeneauftraege/detail/:uid" element={<EigeneAuftraegeDetail />}></Route>

                    <Route path="/agsachbearbeiter/auftrags liste" element={<AgSbAuftragsListe />}></Route>

                    <Route path="/auftrag/" element={<ProtectedRoute><AuftragMain /></ProtectedRoute>}></Route>
                    <Route path="/auftrag/search" element={<ProtectedRoute><AuftragSearch /></ProtectedRoute>}></Route>
                    <Route path=".auftragdetails" element={<ProtectedRoute><AuftragDetails /></ProtectedRoute>}></Route>
                    <Route path=":page/.auftragdetails" element={<ProtectedRoute><AuftragDetails /></ProtectedRoute>}></Route>
                    <Route path=":page/:page/.auftragdetails" element={<ProtectedRoute><AuftragDetails /></ProtectedRoute>}></Route>
                    <Route path="/ticket/" element={<TicketMain />}></Route>
                    <Route path="/chat" element={<ChatListe />}></Route>

                    <Route path="/agsachbearbeiter/auftragsliste" element={<AgSbAuftragsListe />}></Route>

                    <Route path="/admin/profiles/" element={<ProfileMain />}></Route>
                    <Route path="/admin/profiles/detail" element={<ProfileDetail />}></Route>
                    <Route path="/admin/auftraggeber/" element={<AuftraggeberMain />}></Route>
                    <Route path="/admin/auftraggeber/detail" element={<AuftraggeberDetail />}></Route>
                    <Route path="/admin/rechnungsempfaenger/" element={<RechnungsempfaengerMain />}></Route>
                    <Route path="/admin/rechnungsempfaenger/detail" element={<RechnungsempfaengerDetail />}></Route>
                    <Route path="/admin/dienstleistung/" element={<DienstleistungMain />}></Route>
                    <Route path="/admin/dienstleistung/detail" element={<DienstleistungDetail />}></Route>
                    <Route path="/admin/mwstsatz/" element={<MwstSatzMain />}></Route>
                    <Route path="/admin/preise/" element={<PreiseMain />}></Route>
                    <Route path="/admin/preise/detail" element={<PreiseDetail />}></Route>
                    <Route path="/admin/parameter/" element={<ParameterMain />}></Route>
                    <Route path="/admin/parameter/detail" element={<ParameterDetail />}></Route>
                    <Route path="/admin/papierkorb/" element={<PapierkorbMain />}></Route>
                    <Route path="/admin/errormessages/" element={<ErrorMessages />}></Route>

                    <Route path="/faktura/listeAbrechenbareDl" element={<ListeAbrechenbareDienstleistungen />}></Route>
                    <Route path="/faktura/ausgangsrechnungen" element={<Ausgangsrechnungen />}></Route>
                    <Route path="/faktura/rechnungslaufListe" element={<RechnungslaufListe />}></Route>
                    <Route path="/faktura/rechnungslaufListe/vorschau" element={<RechnungslaufVorschau />}></Route>
                    <Route path="/faktura/rechnungslaufDetail" element={<RechnungslaufDetail />}></Route>
                    <Route path="/faktura/rechnungsnummerAnpassen" element={<RechnungsnummerAnpassen />}></Route>

                    <Route path="/manager/profiles" element={<ManagerProfileMain />}></Route>
                    <Route path="/manager/profiles/detail" element={<ManagerProfileDetail />}></Route>
                    <Route path="/manager/profiles/auftraege" element={<ManagerProfileAuftraege />}></Route>

                </Routes>
            </Provider>
        </>
    );
}
